import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {Link} from 'react-router-dom';
import React, {Component} from 'react';

import * as RouteUtils from '../../utils/Route';
import * as ImageUtils from '../../utils/Image';
import * as PropertyUrils from '../../utils/Property';
import * as ImageConst from '../../constants/Image';
import * as ObjectConst from '../../constants/Property';

const propTypes = {
    searchLink: PropTypes.string,
    requiredType: PropTypes.string,
    isNeedInANewTab: PropTypes.bool,
    object: PropTypes.object.isRequired
};

class PropertyPreview extends Component {
    getLinkToPathname = () => {
        const {requiredType, object} = this.props;
        let pathname;

        if (requiredType !== undefined) {
            pathname = `${RouteUtils.getPropertyPathname(object.id)}?type=${requiredType}`;
        } else {
            pathname = RouteUtils.getPropertyPathname(object.id);
        }
        return pathname;
    };

    render() {
        let {object: property, isNeedInANewTab, searchLink, code, i18n, requiredType} = this.props;

        return (
            <div className={classnames('last-item', {
                'bage': property.props.rangeType === ObjectConst.RANGE_TYPE.EXCLUSIVE
            })}>
                <Link
                    className="item-inner price-tm"
                    target={isNeedInANewTab ? '_blank' : ''}
                    to={{
                        pathname: this.getLinkToPathname(),
                        search: searchLink !== undefined ? searchLink : ''
                    }}
                >
                    <div
                        className="last-item-img"
                        style={{
                            backgroundImage: `url(${property.meta.images !== null ?
                                ImageUtils.getSrc(property.meta.images[0].id, ImageConst.TYPE.THUMBS) : ''})`
                        }}
                    >
                        {PropertyUrils.getPriceRentBlock(property, i18n, requiredType)}
                    </div>
                    <div className="last-item-title">
                        {PropertyUrils.getDisplayName(code, property)}
                    </div>

                    <div className="last-item-footer">
                        <div className="last-item-geo">
                            <i />
                            <span>{property.userAddress.city}</span>
                        </div>
                        <div className="icons-boxed">
                            <div className="icons-boxed">
                                <span className="icon icon-person">{property.props.countGuest}</span>
                                <span className="icon icon-bad">{property.props.countBeds}</span>
                                <span className="icon icon-quadrature">{property.props.area}</span>
                                <span className="icon icon-bath">{property.props.countBathrooms}</span>
                            </div>
                        </div>
                    </div>

                </Link>
            </div>
        )
    }
}

PropertyPreview.propTypes = propTypes;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    code: state.languages.currentLanguage.code
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyPreview);



// WEBPACK FOOTER //
// ./src/components/Base/PropertyPreview.js